import React from "react";

const GiftIcon = ({ width = 63, height = 57, fill = "#C8CBCB" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 63 57" fill="none">
      <path
        opacity="0.5"
        d="M52.3563 11.3818C53.4262 10.1981 54.0636 8.71846 54.0636 7.11135C54.0636 3.23243 50.1209 0 45.5272 0C38.0744 0 33.4033 4.31598 31.3091 7.44825C29.2103 4.31598 24.5255 0 17.0727 0C12.479 0 8.53635 3.23243 8.53635 7.1159C8.53635 8.71846 9.16918 10.1981 10.2436 11.3864H0V28.4545H2.84545V51.2181C10.9903 54.8057 20.7604 56.9181 31.3 56.909C41.8395 56.8999 51.6142 54.8193 59.7545 51.2181V28.4545H62.5999V11.3818H52.3563ZM17.8239 4.88052C25.2722 4.88052 28.4545 11.3818 28.4545 11.3818H17.8239C15.8526 11.3818 14.2546 9.85664 14.2546 8.08563C14.2546 6.31462 15.8526 4.88052 17.8239 4.88052ZM22.7636 50.7492C17.7328 50.1938 12.957 49.1466 8.53635 47.6989V28.4545H22.7636V50.7492ZM22.7636 22.7636H5.6909V17.0727H22.7636V22.7636ZM34.1454 51.1589C33.203 51.1954 32.256 51.2181 31.3 51.2181H31.2817C30.3302 51.2181 29.3924 51.1954 28.4545 51.1635V17.0727H34.1454V51.1589ZM44.8306 4.88052C46.802 4.88052 48.4 6.31462 48.4 8.09019C48.4 9.86575 46.802 11.3864 44.8306 11.3864H34.1454C34.1454 11.3818 37.3824 4.88052 44.8306 4.88052ZM54.0636 47.6989C49.6474 49.1466 44.8671 50.1846 39.8363 50.7401V28.4545H54.0636V47.6989ZM56.909 22.7636H39.8363V17.0727H56.909V22.7636Z"
        fill={fill}
      />
    </svg>
  );
};

GiftIcon.defaultProps = {
  width: 63,
  height: 57,
  fill: "white",
};

export default GiftIcon;
